module.exports = __webpack_public_path__ + "img/glasses-round.e02fd7b5.svg";